<template>
    <div class="app-container">
        <div class="x-nav">
            <el-breadcrumb :separator="'＞'">
                <el-breadcrumb-item @click="cancel"><a>{{form.groupName}}</a></el-breadcrumb-item>
                <el-breadcrumb-item>编辑信息</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <el-card shadow="never" style="height: calc(100vh - 160px);overflow: auto;">
            <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="群组名称" prop="groupName">
                            <el-input v-model="form.groupName" placeholder="最多32个字" maxlength="32" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="群组头像" prop="groupAvatar">
                            <el-upload class="avatar-uploader"
                                       :action="serviceUrl+'/businessservice/teachingGroup/uploadAvatar'"
                                :show-file-list="false" :on-success="handleAvatarSuccess" :headers="{ token }"
                                :before-upload="beforeAvatarUpload">
                                <img v-if="form.groupAvatar" :src="form.groupAvatar" class="avatar" style="position:absolute" />
                                <el-icon class="avatar-uploader-icon" style="font-size:100px;">
                                    <Plus />
                                </el-icon>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="form.groupNature == 2 || form.groupNature == 3">
                    <el-col :span="14">
                        <el-form-item label="简介" prop="groupIntroduce">
                            <el-input type="textarea" :rows="8" maxlength="1000" v-model="form.groupIntroduce" />
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-card>
        <div>
            <div class="disflex-row-center cusbtbtn" :style="$store.state.zdy.isActive ? 'left:26px;' : 'left:226px;'">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="submitForm">保 存</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { groupInfo, groupUpdateInfo} from "@/api/admin/system";
import { serviceUrl } from "@/utils/global"

export default {
    name: "groupEdit",
    components: {
    },
    data() {
        return {
            serviceUrl,
            groupId: '',
            token: this.$storage.get("token"),
            // 遮罩层
            loading: true,
            // 非单个禁用
            single: true,
            // 表单参数
            form: {
                groupId: '',
                groupName: '',
                groupIntroduce: '',
                groupAvatar:'https://free-back.oss-cn-beijing.aliyuncs.com/ygjy/group/cover/group.png'
            },
            // 表单校验
            rules: {
                groupName: [
                    { required: true, message: "请输入群组名称", trigger: "blur" },
                ],
                groupIntroduce: [
                    { required: true, message: "请输入群组介绍", trigger: "blur" },
                ],
            },
            delFileList: [],
        };
    },
    created() {
    },
    mounted() {
        if (this.$route.query.groupId) {
            this.groupId = this.$route.query.groupId
            this.getGroupInfo()
        }
    },
    unmounted() {
    },
    computed: {
    },
    methods: {
        getGroupInfo() {
            groupInfo({ groupId: this.groupId }).then(res => {
                  if (res.data.code === 1) {
                      this.form = res.data.data;
                  }else {
                      this.$message.error("请求出错")
                  }
            })
        },
        handleAvatarSuccess(response, uploadFile) {
            console.log(response, uploadFile);
            if (uploadFile.response.code == 1) {
                this.form.groupAvatar = uploadFile.response.data;
            } else {
                this.$message.error("上传失败")
            }

        },
        beforeAvatarUpload(rawFile) {
            console.log(rawFile)
            if (!(rawFile.type == 'image/jpeg' || rawFile.type == 'image/png' || rawFile.type == 'image/jpg')) {
                this.$message.error('图片必须是jpeg、png、jpg格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 10) {
                this.$message.error('图片大小不能超过10M')
                return false
            }
            return true
        },
        submitForm(){
            this.$refs["form"].validate(valid => {
                if (valid) {
                    groupUpdateInfo(this.form).then(res => {
                        if (res.data.code === 1) {
                            this.$message.success("操作成功");
                            this.cancel();
                        } else {
                            this.$message.error("操作失败")
                        }
                    })
                }
            })
        },
        // 取消按钮
        cancel() {
            if (this.form.groupNature==='2'){
                this.replace('/teaStudioManage')
            }else {
                this.replace('/rectorStudioManager')
            }

        },
    }
};
</script>
<style scoped>
.avatar-uploader .avatar {
    width: 178px;
    height: 178px;
    display: block;
    object-fit: cover;
}

.avatar-uploader /deep/ .el-upload {
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
}

.avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
}

.el-icon.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    text-align: center;
}

/deep/ .el-input-group__append {
    background: var(--el-color-primary);
    color: #fff;
}

/deep/ .el-dialog__body {
    padding: 10px 20px !important;
}

.custom /deep/ .el-checkbox {
    height: auto !important;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.custom /deep/ .el-checkbox-group {
    display: flex;
    flex-wrap: wrap;
}

.custom /deep/ .el-checkbox__label {
    padding-left: 0px !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
}

.custom {
    height: calc(100vh - 500px);
    overflow-y: auto;
}

.csbbb {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
    position: relative;
}

.ylsb {
    height: 50vh;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
}

.ylqs {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 7px;
    padding: 5px;
    cursor: pointer;
}

.eicon {
    display: none;
    position: absolute;
    top: 10px;
    right: 10px;
    padding: 5px;
    background: #dbdbdb;
}

.csbbb:hover .eicon {
    display: block;
}
</style>